import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Slide from '@mui/material/Slide'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import { useMe } from '@shared/providers/src/MeProvider'
import { getTestId } from '@shared/utils'

import { useOrderVaccines } from './VaccinesForm.hooks'

export default function ConfirmVaccines({ patientId, encounterId, selectedVaccines, onBack, onNext, ...rest }) {
  const testId = getTestId(rest, 'confirm-vaccines')
  const createVaccineOrder = useOrderVaccines(patientId, encounterId)
  const user = useMe()
  const handleConfirmation = () =>
    createVaccineOrder.mutateAsync({ provider_id: user.providerId, vaccine_ids: selectedVaccines.map((v) => v.id) }).then(() => {
      onNext()
    })

  return (
    <Slide in direction="left">
      <Stack sx={{ justifyContent: 'space-between', minHeight: '400px', height: '100%' }}>
        <Stack>
          <Stack sx={{ p: 2 }}>
            <Typography>Recommend the following vaccines?</Typography>
          </Stack>
          <List disablePadding data-testid={`${testId}-vaccines`}>
            {selectedVaccines
              .sort((a, b) => a.name > b.name)
              .map((vaccine) => (
                <ListItemButton key={vaccine.id} selected divider sx={{ pointerEvents: 'none' }}>
                  <ListItemText primary={vaccine.name} secondary={vaccine.description} />
                </ListItemButton>
              ))}
          </List>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between', p: 2 }}>
          <Box sx={{ width: '50%' }}>
            <Button fullWidth size="large" variant="text" color="inherit" onClick={() => onBack()} data-testid={`${testId}-back`}>
              Back
            </Button>
          </Box>
          <Box sx={{ width: '50%' }}>
            <Button
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => handleConfirmation()}
              data-testid={`${testId}-next`}
            >
              Recommend
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Slide>
  )
}
